import InboxMenu from "./InboxMenu";
export default InboxMenu;